"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typeChecks_1 = require("./typeChecks");

function defaultGetKeyFn(item) {
  return item ? item.toString() : '';
}

function filterOutEmpty(collection, getValueFn) {
  if (!getValueFn) {
    getValueFn = function getValueFn(item) {
      return item;
    };
  }

  return collection.filter(function (item) {
    return !typeChecks_1.isNullOrEmpty(getValueFn(item));
  });
}

exports.filterOutEmpty = filterOutEmpty;

function findWithMatchingProperties(collection, matchingProperties) {
  return (collection || []).find(function (item) {
    return Object.keys(matchingProperties).every(function (key) {
      return item[key] === matchingProperties[key];
    });
  });
}

exports.findWithMatchingProperties = findWithMatchingProperties;

function filterWithMatchingProperties(collection, matchingProperties) {
  return (collection || []).filter(function (item) {
    return Object.keys(matchingProperties).every(function (key) {
      return item[key] === matchingProperties[key];
    });
  });
}

exports.filterWithMatchingProperties = filterWithMatchingProperties;

function pivotCollection(collection, getKeyFn, getValueFn) {
  if (getValueFn === void 0) {
    getValueFn = function getValueFn(value) {
      return value;
    };
  }

  return (collection || []).reduce(function (acc, element) {
    var key = getKeyFn(element);
    acc[key] = getValueFn(element);
    return acc;
  }, {});
}

exports.pivotCollection = pivotCollection;

function sortBy(collection, getValueFn, order, culture) {
  if (order === void 0) {
    order = 'ASC';
  }

  return (collection || []).sort(function (a, b) {
    var aValue = getValueFn(a);
    var bValue = getValueFn(b);
    var response = aValue.localeCompare(bValue, culture);

    if (order === 'DESC') {
      response = response * -1;
    }

    return response;
  });
}

exports.sortBy = sortBy;

function sortByDate(collection, getStringDateFn, order) {
  if (order === void 0) {
    order = 'ASC';
  }

  if (collection) {
    var sorted = collection.map(function (item) {
      var stringDateValue = getStringDateFn(item);
      return __assign(__assign({}, item), {
        _sortDate: stringDateValue ? new Date(stringDateValue).getTime() : 0
      });
    });
    sorted = sorted.sort(function (a, b) {
      var result = a._sortDate - b._sortDate;

      if (order === 'DESC') {
        result = result * -1;
      }

      return result;
    });
    return sorted.map(function (_a) {
      var _sortDate = _a._sortDate,
          props = __rest(_a, ["_sortDate"]);

      return props;
    });
  }

  return collection;
}

exports.sortByDate = sortByDate;

function mapToObject(collection, getKeyFn) {
  var mappedObject = {};

  for (var _i = 0, collection_1 = collection; _i < collection_1.length; _i++) {
    var item = collection_1[_i];
    var itemKey = getKeyFn(item);
    mappedObject[itemKey] = item;
  }

  return mappedObject;
}

function union(first, second, getKeyFn) {
  if (typeChecks_1.isNullOrUndefined(first) || typeChecks_1.isNullOrUndefined(second)) {
    return null;
  }

  if (!getKeyFn) {
    getKeyFn = defaultGetKeyFn;
  }

  var mappedObject = mapToObject(__spreadArrays(first, second), getKeyFn);
  var result = Object.keys(mappedObject).map(function (e) {
    return mappedObject[e];
  });
  return result;
}

exports.union = union;

function intersect(first, second, getKeyFn) {
  if (typeChecks_1.isNullOrUndefined(first) || typeChecks_1.isNullOrUndefined(second)) {
    return null;
  }

  if (!getKeyFn) {
    getKeyFn = defaultGetKeyFn;
  }

  var mappedObject = mapToObject(second, getKeyFn);
  var result = first.filter(function (item) {
    var itemKey = getKeyFn(item);
    return mappedObject[itemKey];
  });
  return result;
}

exports.intersect = intersect;

function except(first, second, getKeyFn) {
  if (typeChecks_1.isNullOrUndefined(first) || typeChecks_1.isNullOrUndefined(second)) {
    return null;
  }

  if (!getKeyFn) {
    getKeyFn = defaultGetKeyFn;
  }

  var mappedObject = mapToObject(second, getKeyFn);
  var result = first.filter(function (item) {
    var itemKey = getKeyFn(item);
    return !mappedObject[itemKey];
  });
  return result;
}

exports.except = except;

function groupBy(collection, getValueFn) {
  return (collection || []).reduce(function (acc, obj) {
    var value = getValueFn(obj);
    acc[value] = (acc[value] || []).concat(obj);
    return acc;
  }, {});
}

exports.groupBy = groupBy;

function split(collection, itemsPerRow, isBreakpoint) {
  if (itemsPerRow === void 0) {
    itemsPerRow = 1;
  }

  if (typeChecks_1.isNullOrUndefined(collection)) {
    return [];
  }

  if (!isBreakpoint) {
    isBreakpoint = function isBreakpoint(element) {
      return false;
    };
  }

  if (typeChecks_1.isNullOrUndefined(itemsPerRow) || itemsPerRow < 1) {
    itemsPerRow = 1;
  }

  var rows = [];
  var currentRow = [];
  var count = 0;

  for (var _i = 0, collection_2 = collection; _i < collection_2.length; _i++) {
    var element = collection_2[_i];

    if (count === itemsPerRow || isBreakpoint(element)) {
      rows.push(currentRow);
      currentRow = [];
      count = 0;
    }

    currentRow.push(element);
    count++;
  }

  rows.push(currentRow);
  return rows;
}

exports.split = split;

function unique(collection, getValueFn) {
  if (typeChecks_1.isNullOrUndefined(collection)) {
    return [];
  } // get keys to determine unique collection


  var keys = collection.map(function (obj) {
    return getValueFn(obj);
  }); // filter collection to bring back a unique list based on the keys

  var uniqueCollection = collection.filter(function (obj, pos, arr) {
    // indexOf returns the index of the first occurrence, using this logic,
    // we can filter out the duplicates that don't match the with the first occurrence therefore giving us a unique list.
    var value = getValueFn(obj);
    return keys.indexOf(value) === pos;
  });
  return uniqueCollection;
}

exports.unique = unique;